import {mapValues, pick} from 'lodash'
import routeNames from './route-names'
import BaseRouterView from '@/components/base/BaseRouterView'

const CancellationsTabs = () => import(/* webpackChunkName: "cancellations" */'@/views/cancellation/CancellationsTabs')
const Cancellations = () => import(/* webpackChunkName: "cancellations" */'@/views/cancellation/Cancellations')
const Cancellation = () => import(/* webpackChunkName: "cancellations" */'@/views/cancellation/cancellation/Cancellation')
const ManageCancellation = () => import(/* webpackChunkName: "cancellations" */'@/views/cancellation/cancellation/ManageCancellation')
const Overview = () => import(/* webpackChunkName: "cancellations" */'@/views/cancellation/cancellation/Overview')

const Summary = () => import(/* webpackChunkName: "cancellations" */'@/views/cancellation/summary/Summary')
const SummaryReasons = () => import(/* webpackChunkName: "cancellations" */'@/views/cancellation/summary/Reasons')

function props ({params}) {
    const props = pick(params, [
        'cancellationId',
        'periodId'
    ])

    return mapValues(props, Number)
}

export default {
    path: '/customers/cancellations',
    component: BaseRouterView,
    children: [
        {
            path: '/',
            component: CancellationsTabs,
            children: [
                {
                    path: '/',
                    name: routeNames.CANCELLATIONS_SUMMARY,
                    meta: {title: 'Summary'},
                    component: Summary,
                    children: [
                        {
                            path: ':periodId/reasons',
                            name: routeNames.CANCELLATIONS_SUMMARY_REASONS,
                            meta: {title: 'Summary Reasons'},
                            props,
                            component: SummaryReasons
                        }
                    ]
                },
                {
                    path: 'list',
                    name: routeNames.CANCELLATIONS,
                    meta: {title: 'List'},
                    component: Cancellations,
                    children: [
                        {
                            path: '/update/:cancellationId',
                            name: routeNames.CANCELLATION_UPDATE,
                            meta: {title: 'Update Cancellation'},
                            component: ManageCancellation,
                            props
                        }
                    ]
                }
            ]
        },
        {
            path: ':cancellationId',
            component: Cancellation,
            props,
            children: [
                {
                    path: '/',
                    name: routeNames.CANCELLATION,
                    meta: {title: 'Cancellation'},
                    component: Overview,
                    props
                }
            ]
        }
    ]
}
